<template lang="pug">
.thumbs.custom-scroll.hide-scroll(
  ref="scrollArea"
  v-drag-scroll="{vertical: vertical}"
  @scroll="onScroll"
)
  StaticImage.thumb(
    v-for="(src, index) in thumbnails"
    :key="index"
    @click="clickImage(index)"
    :alt="'Product Thumbnail '+index"
    :src="src"
    :width="thumbSize"
    lazy
    :class="index === modelValue && 'active'"
  )
  ArrowScroll.thumbs-controls(
    ref="navs"
    :targetRef="scrollArea"
    :vertical="vertical"
    prevLabel="Previous thumbnails"
    nextLabel="Next thumbnails"
    @scroll="$refs.scrollArea.scroll($event)"
  )
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import ArrowScroll from '../../../arrow-scroll.vue'
import { getCloudinaryUrl } from '../../../../js/helpers'
import { useRogue } from '../../../../js/rogue'
import { useMQ } from '../../../../js/mq'

const props = defineProps<{
  gallery: { link?: string, src: string }[],
  modelValue: number,
  product: { name: string, sku: string},
}>()

const mq = useMQ()

const vertical = computed(() => {
  const mqValue = mq.value
  
  return ['mobile', 'tablet'].indexOf(mqValue) === -1
})

const emit = defineEmits<{
  'update:modelValue': [index: number]
}>()

const rogue = useRogue()

const scrollArea = ref<HTMLElement | null>(null)
const navs = ref<typeof ArrowScroll | null>(null)

const thumbSize = 100
const thumbnails = computed(() => props.gallery.map(g => getCloudinaryUrl(g.link || g.src, thumbSize, thumbSize)))

function onScroll(event: Event) {
  if (navs.value) {
    navs.value.onScroll(event)
  }
}

function clickImage(index: number) {
  emit('update:modelValue', index)
  rogue.track.track({type: 'custom', event: 'Gallery Image Click', data: { name: props.product.name, sku: props.product.sku, imageIdx: index }})
}
</script>
<style lang="scss" scoped>
.thumbs {
  display: flex;
  align-items: center;

  @include all-desktop() {
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    overscroll-behavior-y: contain;
  }

  @include not-desktop() {
    flex-direction: row;
    overflow-x: auto;
    overscroll-behavior-x: contain;
    width: 100%;
  }
}

.thumbs-controls {
  @include not-desktop() {
    display: none !important;
  }

  @include tablet() {
    height: 100px;
  }

  @include all-desktop() {
    width: 100px;
    left: 50% !important;
    transform: translateX(-50%);
  }
}

.thumb {
  flex-shrink: 0;
  width: 100px;
  height: 100px;
  margin-bottom: 4px;
  cursor: pointer;

  &.active {
    border: 1px solid black;
  }

  @include not-desktop() {
    margin-bottom: 0;
    margin-right: 4px;
  }

  @include mobile() {
    width: 65px;
    height: 65px;
  }
}
</style>
<style lang="scss" scoped>
.media.zoomed {
  .custom-scroll.hide-scroll {
    scrollbar-width: none !important; /* Firefox */
    -ms-overflow-style: none !important; /* Internet Explorer 10+ */
  }

  .custom-scroll.hide-scroll::-webkit-scrollbar { /* WebKit */
    width: 0 !important;
    height: 0 !important;
  }
}

@include all-desktop() {
  .custom-scroll.hide-scroll {
    scrollbar-width: none !important; /* Firefox */
    -ms-overflow-style: none !important; /* Internet Explorer 10+ */
  }

  .custom-scroll.hide-scroll::-webkit-scrollbar { /* WebKit */
    width: 0 !important;
    height: 0 !important;
  }
}
</style>